import { FC, memo, useState } from "react";
import EmailFragmentTwo from '@buzzeasy/email-fragment-2';
import styled from "styled-components";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";
import { useAppSelector} from "../../../redux/hooks";
import { dxpLayout } from "../../../style/theme";
import useFragmentBaseProps from '../../../hooks/useFragmentBaseProps';

interface IProps {
  workItem: IWorkItem;
}

const RootContainer = styled.div`
  width: 100%;
  height: calc(100% - ${dxpLayout.workItemHeaderHeight});
`;

const EmailFragment: FC<IProps> = memo(({ workItem }) => {
  const fragmentBaseProps = useFragmentBaseProps(workItem.businessUnitId);
  const [expanded, setExpanded] = useState(true);
  const hideContacts = useAppSelector(
    (state) => state.blenderState.agentClientState.agentProperties.displaySettings.hideExternalContacts
  );

  return (
    <RootContainer>
       {<EmailFragmentTwo
          {...fragmentBaseProps}
          isFocused={false}
          onFocusRequested={() => console.log('onFocusRequested')}
          expanded={expanded}
          onExpandedChangeRequested={(expanded: boolean) => setExpanded(expanded)}
          conversationId={workItem.primaryConversationId}
          hideExternalContacts={hideContacts}
        />}
    </RootContainer>
  );
});

export default EmailFragment;
